<template lang="pug">
.v-converter.converter(v-if="data" :class="['converter--' + theme]" :id="data?.id")
	.converter__item
		.converter__item-head
			.converter__item-title(v-if="data.saleLabel") {{data.saleLabel}}
			.converter__currency
				v-field(:field="saleCurrency" v-model="saleCurrency.value" @update:model-value="fieldChanged(lastInput, $event)")
		.converter__field
			v-field(:field="sale" v-model="sale.value" @keyup="fieldChanged(sale, $event)" :theme="'dark'")
	.converter__item
		.converter__item-head
			.converter__item-title(v-if="data.buyingLabel") {{data.buyingLabel}}
			.converter__currency
				v-field(:field="buyingCurrency" v-model="buyingCurrency.value" @update:model-value="fieldChanged(lastInput, $event)")
		.converter__field
			v-field(:field="buying" v-model="buying.value" @keyup="fieldChanged(buying, $event)" :theme="'dark'")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import {nextTick} from "vue";


export default {
	mixins: [
		sourceMixin
	],

	props: {
		theme: {
			type: String,
			default: 'dark'
		}
	},

	data() {
		return {
			data: null,
			sale: {
				id: 'SALE',
				type: 'text',
				label: null,
				value: 1
			},
			buying: {
				id: 'BUYING',
				type: 'text',
				label: null
			},
			saleCurrency: {
				id: "SALE_CURRENCY",
				type: 'currency',
				options: [],
				value: 'USD'
			},
			buyingCurrency: {
				id: "BUYING_CURRENCY",
				type: 'currency',
				options: [],
				value: 'BYN'
			},
			lastInput: null
		}
	},

	watch: {
		['saleCurrency.value']() {
			this.setBuyingCurrency();
		}
	},

	methods: {

		dataSet(data) {
			this.data = data;
			this.initFields(data);
		},

		initFields(data = {}) {
			this.sale.label = data.saleLabel;
			this.buying.label = data.buyingLabel;

			if (data.rate) {
				this.saleCurrency.options = Object.keys(data.rate).map(item => ({value: item, text: item, icon: this.getOptionIcon(item)}));
				this.setBuyingCurrency(data);
			}

			if (data.mask) {
				this.sale.mask = data.mask;
				this.buying.mask = data.mask;
			}

			this.fieldChanged(this.sale);
		},

		setBuyingCurrency() {
			this.buyingCurrency = {
				...this.buyingCurrency,
				value: Object.keys(this.data.rate[this.saleCurrency.value]).find(item => item === this.buyingCurrency.value) || Object.keys(this.data.rate[this.saleCurrency.value])[0],
				options: Object.keys(this.data.rate[this.saleCurrency.value]).map(item => ({value: item, text: item, icon: this.getOptionIcon(item)}))
			}
		},

		getOptionIcon(name) {
			return this.data?.icons && this.data.icons[name] ? this.data.icons[name] : `/local/assets/images/currency/${name}.png`;
		},

		async fieldChanged(field, $event) {
			await nextTick();
			// if keys from 0 to 9 or "," was pressed
			if ($event && $event.keyCode && (($event.keyCode && (48 <= $event.keyCode && $event.keyCode <= 57) || (96 <= $event.keyCode && $event.keyCode <= 105)) || $event.keyCode === 190 || $event.keyCode === 191 || $event.keyCode === 8) || field.id === 'SALE' || field.id === 'BUYING') {
				if (field.id === 'SALE') {
					this.buying.value = this.sale.value ? Math.round((+this.sale.value * this.data.rate[this.saleCurrency.value][this.buyingCurrency.value]) * 100) / 100 : null;
				}

				if (field.id === 'BUYING') {
					this.sale.value = this.buying.value ? Math.round((+this.buying.value / this.data.rate[this.saleCurrency.value][this.buyingCurrency.value]) * 100) / 100 : null;
				}
				this.lastInput = field;
			}
		}
	}
};
</script>